import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indianCurrency',
    standalone: false
})
export class IndianCurrencyPipe implements PipeTransform {
    transform (value: number | string | null | undefined, addRupee?: boolean): string {
        const parsed = typeof value === 'string' ? parseFloat(value) : value;
        if (parsed === null || parsed === undefined || isNaN(parsed)) {
            return '0.00';
        }
        // Normalize negative zero (-0) so it renders as "0.00", not "-0.00".
        // `-0 === 0` is true, so adding 0 converts -0 to +0 without altering other values.
        const num = parsed === 0 ? 0 : parsed;
        if (addRupee) {
            return '₹ ' + num.toLocaleString('en-IN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
        return num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
}